export default "__VITE_ASSET__QIdBMmHZ__"